import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";
import { managementActions } from "../action-creators";
import type { CommonManagementStateType } from "../type";

const COMMON_MANAGEMENT_STATE: CommonManagementStateType = {
    invalidPredefined: {
        accounts: [],
        contacts: [],
        leads: [],
        companyAsLeads: [],
    },
    currentExportTab: "accounts",
    previousExportTab: "",
    cacheToken: "",
    recordToEnableExport: null,
};

export const commonManagementReducer = createReducer<
    CommonManagementStateType,
    ActionType<typeof managementActions.common>
>(COMMON_MANAGEMENT_STATE)
    .handleAction(managementActions.common.setPreDefinedInvalidFields, (state, { payload }) => ({
        ...state,
        invalidPredefined: {
            ...state.invalidPredefined,
            [payload.tabName]: payload.invalidFields,
        },
    }))
    .handleAction(
        managementActions.common.setCurrentExportTab,
        (state, { payload: { currentTabName, previousTabName } }) => ({
            ...state,
            currentExportTab: currentTabName,
            previousExportTab: previousTabName,
        }),
    )
    .handleAction(managementActions.common.setCacheToken, (state, { payload }) => ({
        ...state,
        cacheToken: payload,
    }))
    .handleAction(managementActions.common.setRecordToEnableExport, (state, { payload }) => ({
        ...state,
        recordToEnableExport: payload,
    }))
    .handleAction(managementActions.common.unloadInvalidPredefined, (state) => ({
        ...state,
        invalidPredefined: COMMON_MANAGEMENT_STATE.invalidPredefined,
    }));
